export default {

  // form and basics
  add: 'اضافة',
  edit: 'تعديل',
  delete: 'حذف',
  back: 'رجوع',
  name: 'الاسم',
  email: 'البريد الالكتروني',
  phone: 'رقم الهاتف',
  password: 'كلمة المرور',
  accountStatus: 'حالة الحساب',
  search: 'بحث',
  active: 'نشط',
  disactive: 'غير نشط',

  // form and basics
  login: 'تسجيل الدخول',
  add: 'اضافة',
  save: 'حفظ',
  edit: 'تعديل',
  delete: 'حذف',
  cancel: 'الفاء',
  back: 'رجوع',
  name: 'الاسم',
  username: 'اسم المستخدم',
  email: 'البريد الالكتروني', 
  phone: 'رقم الهاتف',
  password: 'كلمة المرور',
  oldPassword: 'كلمة المرور السابقة',
  newPassword: 'كلمة المرور الجديدة',
  accountStatus: 'حالة الحساب',
  search: 'بحث',
  choose: 'اختر...',
  active: 'نشط',
  disactive: 'غير نشط',
  allRightsRecieved: 'جميع الحقوق محفوظة',

  // success messages
  savedMessage: 'تم الحفظ',

  // error messages
  errorMessage: 'خطأ',

  // required messages
  nameRequired: 'الاسم مطلوب',
  usernameRequired: 'اسم المستخدم مطلوب',
  emailRequired: 'البريد الالكتروني مطلوب',
  emailValidRequired: 'البريد الالكتروني غير صالح',
  phoneRequired: 'رقم الهاتف مطلوب',
  phoneLengthRequired: 'رقم الهاتف يتكون من 11 رقم',
  passwordRequired: 'كلمة المرور مطلوبة',
  passwordLengthRequired: "كلمة المرور تكون اكثر من 8 احرف",
  accountStatusRequired: 'حالة الحساب مطلوبة',
  userOrPasswordWrong: 'خطأ في اسم المستخدم او كلمة المرور',
  
  // nav
  dashboard: 'لوحة التحكم',
  editAccount: 'تعديل الحساب',
  logout: 'تسجيل الخروج',

  // side nav
  homepage: 'الرئيسية',
  aboutUs: 'عن تخطي',
  consultations: 'استشارات',
  blog: 'المدونة',
  club: 'النوادي',
  personalize: 'شخص نفسك',
  training: 'التدريب النفسي',
  contactUs: 'تواصل معنا',

  // products
  products: 'المنتجات',

  // articles
  articles: 'المقالات',

  // Top navbar (عام)
  nav_home: 'الرئيسية',
  nav_about_takhaty: 'عن تخطي',
  nav_about_company: 'عن الشركة',
  nav_founder: 'مؤسس الموقع',
  nav_experts: 'خبراء تخطي',
  nav_consultations: 'إستشارات',
  nav_blog: 'المدونة',
  nav_clubs: 'النوادى',
  nav_check_yourself: 'شخص نفسك',
  nav_study_practice: 'المدارسة والممارسة',
  nav_creative: 'إبداعات',
  nav_publications: 'إصدارات',
  nav_cme: 'التدريب الطبي المستمر',
  nav_contact: 'تواصل معنا',
  nav_lang_aria: 'اختيار اللغة',
  nav_available_on: 'متوفر على',
  theme_light: 'فاتح',
  theme_dark: 'داكن',
  theme_switch_aria_dark: 'التبديل إلى الوضع الفاتح',
  theme_switch_aria_light: 'التبديل إلى الوضع الداكن',
  theme_switch_title_dark: 'الوضع الداكن مفعّل — اضغط للوضع الفاتح',
  theme_switch_title_light: 'الوضع الفاتح — اضغط للوضع الداكن',

  // Landing page
  landing_hero_line1: 'الشبكة العربية لتخطي الضغوط وتحسين المزاج',
  landing_hero_line2: 'شعارنا "في التخطي حياة وإحتواء"',
  landing_hero_line3: 'شغف . دافعية . إنجاز . تميز',
  landing_platform_title: 'منصة التأهيل النفسي',
  landing_platform_lead: 'فرغ مشكلاتك واصنع ذاتك ففي أغوار نفسك عملاق جاهز لتخطي الضغوط ومشكلات الحياة',
  landing_what_we_offer: 'ماذا نقدم؟',
  landing_box_psych_support: 'منصة الدعم النفسي',
  landing_box_clubs: 'نوادي',
  landing_box_trauma: 'خفف صدمتك',
  landing_box_check_self: 'شخص نفسك',
  landing_box_webinars: 'ندوات',
  landing_box_consultations: 'استشارات',
  landing_download_app: 'حمل التطبيق الآن',
  landing_sessions_title: 'إستشارات فورية ومجدولة',
  landing_sessions_p1: 'يستقبل تَخَطّي كافة الإستشارات التى تتعلق بالمشكلات والإضطرابات النفسية والسلوكية والزوجية، ومشكلات الإدمان، ومشكلات الأطفال والمراهقين.',
  landing_sessions_p2: 'يوفر لك تَخَطّي حجز جلسات بشكل فورى أو من خلال تحديد ميعاد مُسبق.',
  landing_sessions_p3: 'جلسات صوتية أو عن طريق مكالمات الفيديو . ',
  landing_sessions_p4: 'جلسات فردية و مزدوجة ',
  landing_patients_title: 'أبرز الأمراض والحالات',
  landing_patients_info: 'يمكنك التعرف على المشكلات والحالات وتحديد المشكلة التى تعانى منها',
  landing_patients_more: 'المزيد من الامراض والحالات',
  landing_club_title: 'نادي تخطي ',
  landing_club_body: 'هو نادى يضُم مواضيع مختلفة يلتقى فيه المستخدمين كلّا على حسب رغبته حيث يتم عمل لقاءات نفسية عن بعد ويكون محور فعال يخدم الجميع لتخطى الضغوط وتحسين الحالة المزاجية والتطوير الذاتى القائم على الممارسة العلاجية الصحيحة.\n\nيعتمد نادي تَخَطّي على الفعاليات المجهزة بصورة منظمة.\n\nمناقشة كل الموضوعات النفسية فى صورة محموعات.\n\nحضور أفضل وأكفأ الخبراء النفسيين والإنتهاء من النقاشات بتوصيات علاجية قوية تساعد الجميع على تخطي الضغوط والإضطرابات النفسية والمشكلات الحياتية.',
  landing_club_read_more: 'إقرأ المزيد عن نوادي تخطي',
  landing_exams_title: 'شخص نفسك',
  landing_exams_lead_bold: 'إختبارات نفسية أونلاين للكبار والمراهقين و الأطفال',
  landing_exams_quote: '"فأن تعرف ما تعانى منه لهو أول خطوة فى طريق الشفاء، أختبر نفسك، وأصنع ذاتك، وابحث عن معاناتك ستجد أنك الوحيد الذى تستطيع رؤية نفسك لتقرر الإستمرار  فى المعاناة أو التخلص منها "  د.هانى فكرى أبو هاشم',
  landing_exams_btn_adults: 'اختبارات نفسية للكبار',
  landing_exams_btn_teens: 'اختبارات نفسية للمراهقين والاطفال',
  landing_blog_title: 'مدونة تخطي',
  landing_blog_all: 'جميع المقالات',

  // شخص نفسك (/checkYourSelf)
  check_self_steps_title: 'خطوات الإختبار',
  check_self_step_1: '1- إختر الإختبار الذى تود القيام به.',
  check_self_step_2: '2- أجب على الأسئلة المطروحة',
  check_self_step_3: '3- الحصول على النتيجة لمعرفة مستوى الدرجة لديك.',
  check_self_features_title: 'إختبارات تخطي',
  check_self_feature_1: 'التوصيات المنطقية والعلاجية التى تساعدك لتخطي ما تعانى منه.',
  check_self_feature_2: 'التوعية التى تساعدك لتخطي ما تعانى منه.',
  check_self_feature_3:
    'يمكنك مشاركة التقرير مع خبراء تخطي للحصول على تشخيص للأسباب المحتملة لحالتك.',
  check_self_exams_intro:
    'يقدّم موقع تخطي مجموعة من الإختبارات و الأسئلة التى تعطيك تقييماً سريعاً ودقيقاً لحالتك ومعرفة مستوى شدة ما تعانى منه.',
  check_self_questions_label: 'اسئلة',
  check_self_minutes_label: 'دقائق',
  check_self_app_lead: 'يمكنك الآن إجراء الإختبارات بشكل دورى ومعرفة مستوى تقدمك من خلال تطبيق تَخَطي',

  experts_section_h2: 'مختصون وخُبراء تَخَطّي ',
  experts_section_bold: 'أفضل المختصيين والخبراء النفسيين المُرخصين وذوى الخبرة العالية فى الصحة النفسية',
  experts_section_p: 'يحرص خُبراء تخطي على المحافظة على أسرار المشاركين وخصوصيتهم ويستقبلون كافة الإستشارات المتعلقة بالمشكلات النفسية والسلوكية والزوجية ومشكلات الإدمان ومشكلات الأطفال والمراهقين',
  experts_loading_label: 'جاري التحميل',
  experts_loading_text: 'جاري تحميل قائمة الخبراء…',
  experts_grid_empty: 'لا يوجد خبراء في هذه الصفحة',

  experts_degree_prefix: 'حاصل على',
  experts_degree_from: 'من',

  articles_empty: 'لا يوجد مقالات',
  articles_read_more: 'قراءة المزيد',
  articles_load_more_conditions: 'المزيد من الامراض والحالات',

  articles_page_intro:
    'مقالات فى تخصصات و حالات متنوعة ومختلفة تناسب كل الفئات والأعمار',
  articles_page_featured: 'أبرز المقالات',
  articles_filter_type_label: 'الانواع',
  articles_filter_interests_label: 'الاهتمامات',
  articles_interest_required: 'الاهتمام مطلوب',
  articles_subscribe_title: 'يمكنك قراءة المزيد من المقالات بأسرع طريقة من تطبيق تخطي',
  articles_app_unavailable: 'التطبيق غير متاح حاليًا، لكنه سيكون متوفرًا قريبًا.',
  articles_contact_us: 'تواصل معنا',
  articles_card_alt_prefix: 'مقال:',

  article_show_more: 'المزيد',
  article_show_less: 'اقل',
  article_copy_link_title: 'نسخ الرابط',
  article_copy_success_title: 'تم النسخ',
  article_copy_success_body: 'تم نسخ الرابط بنجاح!',
  article_copy_error_title: 'خطأ',
  article_copy_error_body: 'حدث خطأ أثناء نسخ الرابط',

  // About Us (/aboutUs)
  about_intro_title: 'عن تَخَطّي',
  about_intro_subtitle: 'منصة التأهيل النفسي',
  about_founder_label: 'مؤسس الموقع',
  about_founder_name: 'د. هانى فكرى أبو هاشم',
  about_founder_role: 'المؤسس والرئيس التنفيذي',
  about_founder_bio:
    'إستشارى العلاج النفسي والإدمان، ومستشار تدريب دولي معتمد، المدير التنفيذى ومؤسس موقع تَخَطّي www.takhaty.com (الشبكة العربية لتخطي الضغوط وتحسين المزاج)',
  about_message_title: 'رسالة تَخَطّي',
  about_message_p1:
    'تَخَطي هو موقع "الشبكة العربية لتخطي الضغوط وتحسين المزاج" وشعارنا فى التخطي حياة وإحتواء"',
  about_message_p2:
    'التخطي هو قوة كامنة فى النفس تظهر عند التعرض للضغوطات والصدمات والتراكمات النفسية العنيفة، ويعتمد التخطي على إماكنيات الشخص المتاحة لتخطي المواقف الصعبة.',
  about_message_p3:
    'يساعد التخطي على تغيير ردود الأفعال المحتملة أثناء التعرض لتلك المواقف وتقبل المساعدة والدعم النفسي والتعافى من الضغوط والإضطرابات النفسية المصاحبة لها.',
  about_message_quote_intro: 'وهنا تكمن رسالتنا',
  about_message_quote:
    '"فأن تفكر جيداً هو أفضل لك .. وأن تكون مدركاً لتخطي مواقفك فهذا إمتيازاً لك ولمن حولك"',
  about_goal_label: 'هدفنا',
  about_goal_title: 'هدف تَخَطّي',
  about_goal_body:
    'هدفنا الأساسي أن تسعى لزيادة رصيدك من الثروة النفسية الحقيقية وأن تعطي لنفسك مساحة واعية للعقل والجسد لتخطي المشكلات والضغوط الحياتية والوقوف عليها ومعالجتها وحتى لا تتطور إلى إضطرابات عنيفة توقف حياتك عن الإستمرارية، وحتى يمكنك التخطي للنجاح فى دروب الحياة المختلفة.',

  // About CEO (/abouCEO)
  ceo_page_intro_title: 'مؤسس الموقع',
  ceo_page_intro_subtitle: 'تعرف على مؤسس موقع تَخَطي',
  ceo_section_degrees: 'الدرجة العلمية',
  ceo_section_memberships: 'العضويات',
  ceo_section_experience: 'الخبرات',
  ceo_section_publications: 'المؤلفات',
  ceo_section_research: 'الأبحاث العلمية',
  ceo_section_events: 'الفعاليات العلمية',
  ceo_degrees_items: [
    '1- أستاذ دكتور العلاج النفسي و الإدمان.',
    '2- دكتوراه العلاج النفسي ،2012 م.',
  ],
  ceo_memberships_items: [
    '1- عضو الجمعية المصرية للمعالجين النفسيين “جمعن” ، مصر.',
    '2- عضو رابطة الأخصائيين النفسيين “رانم” ، مصر.',
    '3- عضو مؤسسة الأداء للتنمية البشرية والتدريب، مصر.',
    '4-أمين عام “النقابة العامة للتدخل المبكر و الدمج”',
    '5-عضو المدرسة الأوليمبية “التأهيل النفسي الرياضي” ، الإتحاد المصرى للكارتيه، مصر',
  ],
  ceo_experience_items: [
    '1- إستشارى العلاج النفسي والإدمان، وزارة الصحة،مصر.',
    '2- مستشار تدريب دولى معتمد من رئاسة الوزراء المصرية،السعودية.',
    '3- إستشارى علاج نفسي بمركز مطمئنة الطبي، السعودية.',
    '4-مؤسس وحدة السلوك بقسم النفسية والعصبية بمستشفى الأحرار التعليمي،مصر ،2013.',
    '5-مدير التدريب الجامعى لطلبة وباحثى الصحة بمستشفى الأحرار،مصر،2016-2021.',
    '6-التدريس بأقسام الصحة النفسية بالتعليم العالى 2016-2021.',
    '7-إستشارى التنمية النفسية بالمجلس القومى للمرأه ،مصر،2016.',
    '8-رئيس قسم التخاطب وأمراض الكلام ، بمستشفى الأحرار التعليمي ،مصر،2015.',
    '9-إستشارى العلاج النفسي بمستشفى الرحاب للأمراض النفسية والإدمان ،مصر 2014.',
    '10-مدرب برنامج القدرات النفسية والسمات لمتقدمي الكلية العسكرية،مصر 2007.',
    '11- مُحاضر برنامج تطوير الشخصية بأكاديمية أيزو للجودة واللغات مصر 2011.',
    '12-مُعالج نفسي بمركز د. شعلان لللطب النفسي ش.القصر العينى.القاهرة 2004.',
    '13-معالج نفسي بمركز د.جمال أبو العزائم للطب النفسي والإدمان،مصر 2001.',
    '14-مُشرف علمى لصفحة صحتك النفسية تهمنا بجريدة المجتمع العربى ،مصر 2003.',
  ],
  ceo_publications_items: [
    '1- كتاب  الدليل التشخيصي والاحصائي الخامس للاضطرابات النفسية - طبعة مخصصة لأخصائي الادمان وتعاطي المخدرات ( نسخة الكترونية  )',
    '2- كتاب الدليل التشخيصي والاحصائي الخامس للاضطرابات النفسية - طبعة مخصصة لأخصائي الادمان وتعاطي المخدرات ( نسخة الكترونية  )',
    '3- كتاب  الدليل التشخيصي والاحصائي الخامس للاضطرابات النفسية - طبعة مخصصة لأخصائي الادمان وتعاطي المخدرات ( نسخة الكترونية  )',
  ],
  ceo_research_items: [
    '1- إستشارى العلاج النفسي والإدمان، وزارة الصحة،مصر.',
    '2- مستشار تدريب دولى معتمد من رئاسة الوزراء المصرية،السعودية.',
    '3- إستشارى علاج نفسي بمركز مطمئنة الطبي، السعودية.',
    '4-مؤسس وحدة السلوك بقسم النفسية والعصبية بمستشفى الأحرار التعليمي،مصر ،2013.',
    '5-مدير التدريب الجامعى لطلبة وباحثى الصحة بمستشفى الأحرار،مصر،2016-2021.',
    '6-التدريس بأقسام الصحة النفسية بالتعليم العالى 2016-2021.',
    '7-إستشارى التنمية النفسية بالمجلس القومى للمرأه ،مصر،2016.',
    '8- رئيس قسم التخاطب وأمراض الكلام ، بمستشفى الأحرار التعليمي ،مصر،2015.',
    '9-إستشارى العلاج النفسي بمستشفى الرحاب للأمراض النفسية والإدمان ،مصر 2014.',
    '10-مدرب برنامج القدرات النفسية والسمات لمتقدمي الكلية العسكرية،مصر 2007.',
    '11- مُحاضر برنامج تطوير الشخصية بأكاديمية أيزو للجودة واللغات مصر 2011.',
    '12-مُعالج نفسي بمركز د. شعلان لللطب النفسي ش.القصر العينى.القاهرة 2004.',
    '13-معالج نفسي بمركز د.جمال أبو العزائم للطب النفسي والإدمان،مصر 2001.',
    '14-مُشرف علمى لصفحة صحتك النفسية تهمنا بجريدة المجتمع العربى ،مصر 2003.',
    '15-مُشرف علمى لصفحة صحتك النفسية تهمنا بجريدة المجتمع العربى ،مصر 2003.',
    '16-مُشرف علمى لصفحة صحتك النفسية تهمنا بجريدة المجتمع العربى ،مصر 2003.',
    '17-مُشرف علمى لصفحة صحتك النفسية تهمنا بجريدة المجتمع العربى ،مصر 2003.',
  ],
  ceo_events_items: [
    '1- إستشارى العلاج النفسي والإدمان، وزارة الصحة،مصر.',
    '2- مستشار تدريب دولى معتمد من رئاسة الوزراء المصرية،السعودية.',
    '3- إستشارى علاج نفسي بمركز مطمئنة الطبي، السعودية.',
    '4-مؤسس وحدة السلوك بقسم النفسية والعصبية بمستشفى الأحرار التعليمي،مصر ،2013.',
    '5-مدير التدريب الجامعى لطلبة وباحثى الصحة بمستشفى الأحرار،مصر،2016-2021.',
    '6-التدريس بأقسام الصحة النفسية بالتعليم العالى 2016-2021.',
    '7-إستشارى التنمية النفسية بالمجلس القومى للمرأه ،مصر،2016.',
    '8- رئيس قسم التخاطب وأمراض الكلام ، بمستشفى الأحرار التعليمي ،مصر،2015.',
    '9-إستشارى العلاج النفسي بمستشفى الرحاب للأمراض النفسية والإدمان ،مصر 2014.',
  ],

  // Experts page (/experts)
  experts_page_hero_kicker: 'أهلاً بك كأحد',
  experts_page_hero_title: 'خُبراء تخطي',
  experts_page_hero_lead:
    'إنضم الآن إلى منصة تَخَطّي كطبيب ،إستشارى نفسي أو أُسري',
  experts_page_why_title: 'لماذا تكون مُختصاٍ في تَخَطّي',
  experts_page_why_lead:
    'تُقدم تَخَطّي إدارة كاملة لمواعيد جلساتك و دوراتك وندواتك كمختص كما توفر نادى للتحدث والتعرف على المزيد من الحالات المختلفة',
  experts_page_box_club_title: 'نادى تَخَطّي',
  experts_page_box_club_text:
    'مجتمع تَخَطّي يجمع بينك وبين الحالات بشكل سريع ومباشر لمشاركة الأفكار والإستشارات بشكل أسرع مما يساعد الحالات على التعرف عليك كمختص.',
  experts_page_box_privacy_title: 'خصوصية تامة',
  experts_page_box_privacy_text:
    'لا يطلع أي طرف آخر على محادثاتك مع العملاء، فنحن نضمن لك خصوصية تامة مع العميل.',
  experts_page_box_support_title: 'خدمة عملاء',
  experts_page_box_support_text:
    'تَخَطّي يقدم خدمات عملاء احترافية ومتميزة، دعم فعال ومتواصل على مدار الساعة لجميع المختصين والعملاء.',
  experts_page_subscribe_heading:
    'يمكنك قراءة المزيد من المقالات بأسرع طريقة من تطبيق تخطي',
  experts_page_app_unavailable:
    'التطبيق غير متاح حاليًا، لكنه سيكون متوفرًا قريبًا.',

  // Doctor profile (/experts/:id)
  doctor_profile_back: 'العودة للخبراء',
  doctor_profile_loading: 'جاري تحميل البيانات…',
  doctor_profile_retry: 'إعادة المحاولة',
  doctor_profile_ratings_word: 'تقييم',
  doctor_profile_hourly_rate: 'سعر الساعة',
  doctor_profile_currency_egp: 'ج.م',
  doctor_profile_about: 'نبذة',
  doctor_profile_specializations: 'التخصصات',
  doctor_profile_job_title: 'المسمى الوظيفي',
  doctor_profile_academic_degree: 'الدرجة العلمية',
  doctor_profile_interests: 'مجالات الاهتمام',
  doctor_profile_dob: 'تاريخ الميلاد',
  doctor_profile_headline_in: 'في',
  doctor_profile_role_fallback: 'طبيب',
  doctor_profile_err_invalid_id: 'معرّف الطبيب غير صالح',
  doctor_profile_err_not_found: 'تعذّر العثور على بيانات الطبيب',
  doctor_profile_err_not_in_list: 'لم يُعثر على هذا الطبيب في القائمة',
  doctor_profile_err_network:
    'تعذّر تحميل بيانات الطبيب. تحقق من الاتصال أو تسجيل الدخول.',

  // Consultations list (/consultations)
  consult_page_hero_title: 'إستشارات',
  consult_page_hero_lead:
    'أبرز الإستشارات والأسئلة والرد عليها من كبار الخُبراء والمختصين لدى تَخَطّي',
  consult_page_blurb_title: 'إستشارات تخطي',
  consult_page_blurb_body:
    'يستقبل تَخَطّي كافة الإستشارات التى تتعلق بالمشكلات والإضطرابات النفسية والسلوكية والزوجية، ومشكلات الإدمان، ومشكلات الأطفال والمراهقين.',
  consult_page_latest_heading: 'آخر الإستشارات',
  consult_page_empty: 'لا توجد استشارات حالياً',
  consult_meta_consultant: 'الإستشاري',
  consult_meta_published: 'تاريخ النشر',
  consult_meta_views: 'المشاهدات',
  consult_meta_country: 'البلد',
  consult_meta_age: 'العمر',
  consult_card_view_details: 'عرض التفاصيل',
  consult_subscribe_heading: 'يمكنك إرسال إستشارتك من خلال تطبيق تخطي',

  // Consultation detail (/consultation/:id)
  consult_detail_back: '← العودة إلى الاستشارات',
  consult_detail_eyebrow: 'استشارة طبية نفسية',
  consult_detail_loading: 'جاري التحميل…',
  consult_detail_title_fallback: 'استشارة',
  consult_detail_loading_details: 'جاري تحميل التفاصيل…',
  consult_detail_error_title: 'تعذّر تحميل هذه الاستشارة',
  consult_detail_error_hint: 'تحقق من الرابط أو حاول مرة أخرى لاحقاً.',
  consult_detail_back_list_btn: 'العودة إلى الاستشارات',
  consult_detail_section_case_meta: 'تفاصيل الشكوى',
  consult_detail_section_question: 'نص الشكوى',
  consult_detail_section_reply: 'رد الشكوى',
  consult_detail_meta_classification: 'التصنيف',
  consult_detail_meta_date: 'التاريخ',
  consult_detail_meta_gender: 'النوع',
  consult_detail_no_reply_title: 'لا يوجد ردّ بعد',
  consult_detail_no_reply_text:
    'فريق تَخَطّي لم يُعلِن ردّاً على هذه الاستشارة حتى الآن. يُرجى العودة لاحقاً؛ سيُحدَّث هذا القسم فور اعتماد الردّ من المختص.',
  consult_detail_sidebar_title: 'إستشارات تَخَطّي',
  consult_detail_sidebar_body:
    'نستقبل استشاراتكم في الإضطرابات النفسية والسلوكية والزوجية والإدمان وصحة الطفل والمراهق.',
  consult_detail_all_consultations: 'كل الاستشارات',
  consult_detail_strip_title: 'إستشارات تَخَطّي',
  consult_detail_age_suffix: 'عاماً',
  consult_detail_gender_male: 'ذكر',
  consult_detail_gender_female: 'أنثى',

  // Clubs (/clubs)
  clubs_page_hero_title: 'نادى تَخّطِي',
  clubs_page_intro_kicker: 'نبذة عن',
  clubs_page_intro_title: 'نادي تَخّطِي',
  clubs_page_intro_body:
    'هو نادي يلتقي فيه زوار "تَخَطِّي" كلًا على حسب رغبته حيث يتم عمل لقاءات نفسية عن بعد ويكون محورًا فعّالًا يخدم الجميع لتخطي الضغوط وتحسين الحالة المزاجية والتطوير الذاتي القائم على الممارسة العلاجية الصحيحة حيث يعتمد نادينا على الفعاليات المجهزة بصورة منظمة تناقش كل الموضوعات النفسية في صورة مجموعات وبحضور أفضل الخبراء النفسيين حيث يتم النقاش حول موضوع محدد والانتهاء بتوصيات علاجية قوية تساعد الجميع على تخطي الضغوط والاضطرابات النفسية والمشكلات الحياتية بكل بساطة ويسر.',
  clubs_followers_label: 'متابع',
  clubs_posts_label: 'منشور',
  clubs_subscribe_heading:
    'اشترك في نوادي تخطي وشارك أفكارك مع المختصين',
  clubs_loading: 'جاري تحميل النوادي…',
  clubs_empty: 'لا توجد نوادي للعرض حالياً.',
  clubs_load_error: 'تعذّر تحميل النوادي. حاول مرة أخرى لاحقاً.',

  // إبداعات (/creative)
  creative_hero_title: 'إبداعات تَخَطّي',
  creative_hero_subtitle: 'رسومات وكتابات مستخدمي تَخَطّي؛ انضم إلينا وشاركنا إبداعاتك.',
  creative_loading: 'جاري تحميل الإبداعات…',
  creative_empty: 'لا توجد صور لعرضها حالياً.',
  creative_load_more: 'تحميل المزيد',
  creative_zoom_aria: 'تكبير الصورة',
  creative_lb_dialog: 'معاينة الصورة',
  creative_lb_close: 'إغلاق',
  creative_lb_prev: 'الصورة السابقة',
  creative_lb_next: 'الصورة التالية',
  creative_lb_of: 'من',
  creative_default_label: 'إبداع',
  creative_subscribe_heading: 'كن على تواصل دائم مع مستخدمى تطبيق تخطي',

  // التدريب الطبي المستمر (/trainings)
  trainings_hero_title: 'التدريب الطبي المستمر',
  trainings_hero_subtitle:
    'نسعى للتطوير دائماً سواء مع الخُبراء أو المستخدمين؛ نقدم أفضل الدورات والتدريبات لخُبراء تَخطي ليكونوا على وعي دائم بكل جديد في مجال الطب النفسي',
  trainings_section_title: 'التدريب الطبي المستمر',
  trainings_what_about: 'ماذا عنه؟',
  trainings_about_body:
    'تهتم تَخَطّي ليس بالزوار فقط ولكن أيضاً بكل خبير من عائلة تَخَطّي، حيث أن هدفنا الرئيسي هو الوصول لأفضل النتائج مع الزوار والحالات وذلك لم يتم إلا بسعي للتطوير المستمر والوصول لأحدث طرق العلاج والمساعدة للحالات، لذلك تحرص تَخَطّي على توفير كافة الدورات والتدريبات لخُبرائها وتدريبهم على أحدث الأساليب وإعدادهم للتميز والتطوير الدائم.',
  trainings_goals_title: 'اهداف التدريب الطبي',
  trainings_goal_1: 'التطوير والسعى المستمر لضمان الحصول على أفضل النتائج',
  trainings_goal_2: 'ضمان وصول الخُبراء لأحدث أساليب العلاج',
  trainings_goal_3: 'توفير أحدث الدورات والتدريبات وكل ما يحتاجه الخُبراء في مكان واحد',
  trainings_courses_title: 'دورات التدريب الطبي',
  trainings_subscribe_heading: 'تريد التعرف على كافة الدورات والتدريبات والإشتراك بهم؟',

  // كُتب (/books)
  books_hero_title: 'كُتب تَخَطّي',
  books_hero_subtitle: 'كُتب في تخصصات وحالات متنوعة ومختلفة تناسب كل الفئات والأعمار',
  books_latest: 'أحدث الكتب',
  books_loading: 'جاري تحميل الكتب…',
  books_empty: 'لا توجد كتب حالياً',
  books_alt_cover: 'غلاف الكتاب',
  books_placeholder_title: 'كتاب',
  books_doctor_label: 'الطبيب',
  books_cta_open: 'فتح / تحميل الكتاب',
  books_viewer_external_link: 'رابط خارجي',
  books_viewer_close: 'إغلاق',
  books_viewer_pdf_title: 'معاينة الكتاب',
  books_open_new_tab: 'فتح في تبويب جديد',
  books_toggle_to_direct: 'عرض مباشر من الرابط',
  books_toggle_to_google: 'عرض عبر Google',
  books_viewer_hint:
    'بعض المواقع تمنع عرض ملف PDF داخل الصفحة فيُعاد ضبط الاتصال؛ جرّب «عرض عبر Google» أو «فتح في تبويب جديد».',
  books_viewer_fallback_text:
    'هذا الرابط يفتح موقعاً خارجياً وليس ملف PDF مباشر في المتصفح.',
  books_open_link: 'فتح الرابط',

  // تواصل معنا (/contactUs)
  contact_page_title: 'تواصل معنا',
  contact_hero_lead:
    'التواصل لغة لا يتقنها إلا من عرف معناها، وتواصلك معنا سعي للسلمية بين ماضيك وحاضرك ومستقبلك لتخطي مشكلاتك والوصول إلى غايتك، ولتجد دوماً النجاح الشخصي مضيئاً',
  contact_intro_heading: 'تواصل معنا',
  contact_intro_body:
    'أخبرنا إذا كان لديك سؤال أو تريد ترك تعليق أو المزيد من المعلومات حول تخطي. نستقبل رسائلك على البريد التالي وسنعاود الاتصال بك قريباً.',
  contact_label_name: 'الاسم (لن يظهر)',
  contact_label_email: 'البريد الإلكتروني',
  contact_label_country: 'البلد',
  contact_label_subject: 'الموضوع',
  contact_label_message: 'اترك رسالتك',
  contact_placeholder_country: 'ابحث أو اختر الدولة…',
  contact_country_no_results: 'لا توجد نتائج مطابقة',
  contact_country_no_options: 'لا توجد دول متاحة',
  contact_err_name_required: 'الاسم مطلوب',
  contact_err_name_pattern: 'الاسم بين 2 و30 حرفاً (حروف عربية أو إنجليزية فقط)',
  contact_err_email_required: 'البريد الإلكتروني مطلوب',
  contact_err_email_invalid: 'البريد الإلكتروني غير صالح',
  contact_err_country_required: 'البلد مطلوب',
  contact_err_subject_required: 'الموضوع مطلوب',
  contact_err_message_required: 'الرسالة مطلوبة',
  contact_err_message_min: 'الرسالة يجب ألا تقل عن 10 أحرف',
  contact_overlay_sending: 'جاري الإرسال…',
  contact_submit: 'إرسال الرسالة',
  contact_toast_title: 'تواصل معنا',
  contact_toast_error_title: 'خطأ',
  contact_turnstile_load_fail:
    'تعذّر تحميل التحقق (Cloudflare). تحقق من الاتصال أو عطّل حاجب الإعلانات لـ challenges.cloudflare.com ثم حدّث الصفحة.',
  contact_turnstile_fail:
    'فشل التحقق. جرّب تحديث الصفحة أو تأكد أن النطاق localhost مضاف في إعدادات Turnstile بكلودفلير.',
  contact_turnstile_complete_first: 'أكمل «التحقق» أسفل النموذج قبل الإرسال.',
  contact_countries_load_fail: 'تعذّر تحميل قائمة الدول',
  contact_success: 'تم إرسال رسالتك بنجاح. سنتواصل معك قريباً.',
  contact_send_error: 'حدث خطأ أثناء الإرسال. حاول مرة أخرى.',
  contact_webforms_missing:
    'أضف VUE_APP_WEB3FORMS_ACCESS_KEY في ملف .env ثم أوقف السيرفر تماماً (Ctrl+C) وأعد تشغيل npm run serve — Vue لا يقرأ التعديلات على .env أثناء التشغيل.',
  contact_turnstile_aria: 'التحقق من أنك لست روبوتاً',

  // Footer
  footer_tagline: 'تَخَطي هو موقع "الشبكة العربية لتخطي الضغوط وتحسين المزاج" وشعارنا "فى التخطي حياة وإحتواء"',
  footer_main_links: 'الروابط الأساسية',
  footer_contact_heading: 'جهات الإتصال',
  footer_email_label: 'البريد الالكتروني',
  footer_phone_label: 'رقم الموبايل',
  footer_whatsapp_label: 'واتساب',
  footer_rights: 'جميع الحقوق محفوظة © Takhaty.com',
  footer_blog_link: 'مدونة تَخَطّي',
  footer_club_link: 'نادي تَخَطّي',
  footer_terms: 'الشروط والأحكام',
  footer_privacy: 'سياسة الخصوصية',

};